import { render, staticRenderFns } from "./lifehall.vue?vue&type=template&id=673b37fa&scoped=true"
import script from "./lifehall.vue?vue&type=script&lang=js"
export * from "./lifehall.vue?vue&type=script&lang=js"
import style0 from "./lifehall.vue?vue&type=style&index=0&id=673b37fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673b37fa",
  null
  
)

export default component.exports